import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
  name: "entidadPage",
  data() {
    let ss = new MainService();
    return {
      msg: "entidadPage",
      ss: ss,
      ajax: {
        url: ss.indexEntidad(),
        headers: ss.getToken(),
      },
      columns: [
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          visible: false,
        },
        {
          data: "DT_RowIndex",
          name: "DT_RowIndex",
          title: "N",
          orderable: false,
          searchable: false,
        },
        { data: "Entidad", name: "Entidad", title: "Entidad" },
        { data: "Descripcion", name: "Descripcion", title: "Descripción" },
        {
          data: "action",
          orderable: false,
          title: "Acciones",
          searchable: false,
        },
      ],
      entidads: [],
      entidad: {},
      isLoading: false,
      errorBag: {},
    };
  },
  methods: {
    newEntidad() {
      this.entidad = {};
      this.$refs["frm-entidad"].show();
    },
    showEntidad(id) {
      this.isLoading = true;
      this.ss
        .showEntidad(id)
        .then((result) => {
          let response = result.data;
          this.entidad = response.data;
          this.$refs["view-entidad"].show();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    editEntidad() {
      this.$refs["frm-entidad"].show();
      this.$refs["view-entidad"].hide();
    },
    cancelEntidad() {
      if (this.entidad.id) {
        this.$refs["view-entidad"].show();
      }
      this.$refs["frm-entidad"].hide();
    },
    saveEntidad() {
      this.ss
        .storeEntidad(this.entidad)
        .then((result) => {
          console.log(result);
          let response = result.data;
          this.$bvToast.toast(response.msg, {
            title: this.$t("messages.success"),
            variant: "success",
            autoHideDelay: 5000,
          });
          //this.$refs['view-consulta'].show(); //para volver al modal
          console.log(response);
          this.$refs["frm-entidad"].hide();
          this.$refs["datatable-entidad"].reload();
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast(this.$t("messages.problemSave"), {
            title: "Error",
            variant: "danger",
            autoHideDelay: 5000,
          });
        });
    },
    deleteEntidad() {
      this.$swal({
        title: "Estas seguro que deseas eliminar?",
        text: "Esta accion es irreversible!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete.isConfirmed) {
          this.ss
            .destroyEntidad(this.entidad)
            .then((result) => {
              let response = result.data;
              console.log(response);
              this.$bvToast.toast(response.msg, {
                title: this.$t("messages.success"),
                variant: "success",
                autoHideDelay: 5000,
              });
              this.$refs["view-entidad"].hide();
              this.$refs["datatable-entidad"].reload();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          //swal("Your imaginary file is safe!");
        }
      });
    },
    draw() {
      window.$(".btn-datatable-Entidad").on("click", (evt) => {
        const data = window.$(evt.target)[0].id;
        this.showEntidad(data);
      });
    },
  },
  components: {
    dataTable,
    Loader,
  },
  mounted() {
    var persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Admin/Login");
    } else {
      if (persona.Rol !== 1) {
        this.$router.push("/Admin/Login");
      }
    }
  },
};
